import { Playback } from '../common/constants';
import { DeliveryMode } from '@kollective-frontend/ksdk-api';

export default function deliveryModeToPlayback(dm: DeliveryMode): Playback {
  switch (dm) {
    case DeliveryMode.ECDN11:
      return Playback.ECDN11;
    case DeliveryMode.WEBRTC:
      return Playback.BBP;
    default:
      return Playback.CDN;
  }
}
